"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DealerTile = void 0;
var _react = require("react");
var _LexusButton = _interopRequireDefault(require("../LexusButton"));
var _Link = _interopRequireDefault(require("../Link"));
var _Text = _interopRequireDefault(require("../Text"));
var Styled = _interopRequireWildcard(require("./DealerTile/index.styled"));
var Themes = _interopRequireWildcard(require("./DealerTile/index.themes"));
var _Icon = _interopRequireDefault(require("../../_nextgen/components/Icon"));
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _helper = require("../../applications/SearchInventoryTool/helper");
var _analytics = require("../analytics");
var _jsxRuntime = require("react/jsx-runtime");
const DealerTile = function (props) {
  var _dealer$address, _dealer$address2, _dealer$address3, _dealer$address4, _dealer$address5, _dealer$address6;
  const {
    icon,
    heading,
    subHeading,
    dealer,
    series,
    cta,
    todaysHours
  } = props;
  const themeContext = (0, _styledComponentThemes.useTheme)();
  const theme = typeof themeContext === "string" ? themeContext : themeContext === null || themeContext === void 0 ? void 0 : themeContext.theme;
  const url = (cta === null || cta === void 0 ? void 0 : cta.href) && new URL(cta.href.match(/^http/) ? cta === null || cta === void 0 ? void 0 : cta.href : `${window.location.origin}${cta === null || cta === void 0 ? void 0 : cta.href}`);
  const modifiedBannerCTA = {
    ...cta
  };
  if (url && series && !url.searchParams.get("series")) {
    url.searchParams.append("series", series);
    const bannerUrl = url.toString();
    modifiedBannerCTA.href = bannerUrl;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: props === null || props === void 0 ? void 0 : props.className,
    "data-testid": "DealerTile",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerTile, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.TileSection, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Icon, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            src: icon
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Heading, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: heading
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.SubHeading, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: subHeading
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.TileSection, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerInfoContainer, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerName, {
            children: [dealer !== null && dealer !== void 0 && dealer.name ? dealer.name : "-", " ", /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerDistance, {
              children: ["(", (dealer === null || dealer === void 0 ? void 0 : dealer.distance) !== null && (dealer === null || dealer === void 0 ? void 0 : dealer.distance) !== undefined && (dealer === null || dealer === void 0 ? void 0 : dealer.distance) >= 0 ? `${dealer.distance} mi` : "- mi", ")"]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.PhoneNumber, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
              alt: "Dealer phone number",
              href: `tel:${dealer === null || dealer === void 0 ? void 0 : dealer.phoneNumber}`,
              children: dealer !== null && dealer !== void 0 && dealer.phoneNumber ? dealer.phoneNumber : "(000) 000-0000"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerFlexContainer, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.AddressContainer, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.InfoLine, {
                children: dealer === null || dealer === void 0 ? void 0 : (_dealer$address = dealer.address) === null || _dealer$address === void 0 ? void 0 : _dealer$address.line1
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.InfoLine, {
                children: [dealer === null || dealer === void 0 ? void 0 : (_dealer$address2 = dealer.address) === null || _dealer$address2 === void 0 ? void 0 : _dealer$address2.city, ",", " ", theme === _helper.LEXUS_THEME && `${dealer !== null && dealer !== void 0 && (_dealer$address3 = dealer.address) !== null && _dealer$address3 !== void 0 && _dealer$address3.state ? dealer.address.state : "-"} ${dealer !== null && dealer !== void 0 && (_dealer$address4 = dealer.address) !== null && _dealer$address4 !== void 0 && _dealer$address4.zipCode ? dealer.address.zipCode : "-"}`]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.InfoLine, {
                children: theme !== _helper.LEXUS_THEME && `${(dealer === null || dealer === void 0 ? void 0 : (_dealer$address5 = dealer.address) === null || _dealer$address5 === void 0 ? void 0 : _dealer$address5.state) || "-"} ${(dealer === null || dealer === void 0 ? void 0 : (_dealer$address6 = dealer.address) === null || _dealer$address6 === void 0 ? void 0 : _dealer$address6.zipCode) || "-"}`
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.HoursContainer, {
              children: (dealer === null || dealer === void 0 ? void 0 : dealer.hours) && (theme === _helper.LEXUS_THEME ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.InfoLine, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                    children: todaysHours
                  }), " ", dealer === null || dealer === void 0 ? void 0 : dealer.hours]
                })
              }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.InfoLine, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                    children: todaysHours
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.InfoLine, {
                  children: dealer === null || dealer === void 0 ? void 0 : dealer.hours
                })]
              }))
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LexusButton.default, {
          ...modifiedBannerCTA,
          disableRouter: true
        })]
      })]
    })
  });
};
exports.DealerTile = DealerTile;
const themedDealerTile = (0, _styledComponentThemes.withThemes)(DealerTile, Themes);
var _default = exports.default = /*#__PURE__*/(0, _react.memo)((0, _analytics.withAnalytics)(themedDealerTile)({}));